import { modalBibliographyDetailSetStore } from '@/store'
import { ModalBibliographyDetailSetStoreInterface } from '@/store/ModalBibliographyDetailSetStore'

export class ModalBibliographyDetailSetService {
  public open(params?: ModalBibliographyDetailSetStoreInterface) {
    modalBibliographyDetailSetStore.open(params)
  }

  public close() {
    modalBibliographyDetailSetStore.close()
  }
}
